<script>
  // Shown when a list has nothing in it.
  //
  // Was `<p class="text-center font-bold text-2xl pt-10">Currently no ready
  // scenarios</p>` -- floating 24px bold text on an otherwise blank page, which
  // reads more like an error than an empty list.
  export let icon = "fa-inbox";
  export let title;
  export let hint = "";
</script>

<div
  class="surface mt-6 flex flex-col items-center gap-2 px-6 py-14 text-center"
>
  <i class="fas {icon} text-2xl opacity-25" aria-hidden="true"></i>
  <p class="font-medium">{title}</p>
  {#if hint}
    <p class="max-w-sm text-sm opacity-60">{hint}</p>
  {/if}
  <slot />
</div>
